export const ROUTE_LINKS = {
  login: '/login',
  signUp: '/sign-up',
  postLoginRouter: '/post-login-router',
  onboarding: '/onboarding',
  googleAuth: '/google-auth',
  subscriptionRedirectHandler: '/subscription-redirect',
  googleDriveAuthRedirectHandler: '/google-drive-auth-redirect',
  instagramAuthPopupRedirectHandler: '/instagram-auth-popup-redirect',
  shopifyAuthHandler: '/shopify-auth',
  postBillingSessionHandler: '/post-billing-session-handler',
  verifySignUp: '/verify',
  dashboard: '/dashboard',
  paywall: '/dashboard/paywall',
  overview: '/dashboard/overview',
  smartAssistants: '/dashboard/agents',
  selectSmartAssistantType: '/dashboard/agents/select',
  createSmartAssistant: '/dashboard/agent/create',
  manageSmartAssistant: '/dashboard/agent/manage',
  resources: '/dashboard/knowledge',
  organisation: '/dashboard/organisation',
  organisationUsers: '/dashboard/organisation/users',
  organisationTeams: '/dashboard/organisation/teams',
  settings: '/dashboard/settings',
  billing: '/dashboard/settings/billing',
  integrations: '/dashboard/settings/integrations',
  usage: '/dashboard/settings/usage',
  api: '/dashboard/settings/api',
  stores: '/dashboard/settings/stores',
  byok: '/dashboard/settings/byok',
  whiteLabel: '/dashboard/settings/white-label',
  organisationSettings: '/dashboard/settings/organisation',
  generalSettings: '/dashboard/settings/general',
  smartEditor: '/editor',
  pdfViewer: '/pdf-viewer',
  videoViewer: '/video-viewer',
  youtubeViewer: '/youtube-viewer',
  googleDriveViewer: '/google-drive-viewer',
  websiteViewer: '/website-viewer',
  smartAssistant: '/agent',
  guestSmartAssistant: '/guest-agent',
  guestSmartAssistantDashboard: '/guest-agent/dashboard',
  legacyGuestSmartAssistant: '/guest-chatbot', // Some users have this old url on their website
  back: -1
};

export const NAV_BAR_ITEMS = {
  smartAssistants: 'agents',
  resources: 'knowledge',
  integrations: 'settings/integrations',
  api: 'settings/api',
  usage: 'settings/usage',
  organisationUsers: 'organisation/users',
  organisationTeams: 'organisation/teams'
};

export enum ManageSmartAssistantTabSlug {
  RESOURCES = 'knowledge',
  CONFIGURATION = 'configuration',
  CUSTOMIZATION = 'customization',
  WEBSITE_INTEGRATION = 'website-integration',
  STORE = 'store',
  CONVERSATIONS = 'conversations',
  TOOLS = 'tools',
  LEADS = 'leads',
  PHONE_AGENT_BASICS = 'phone-agent-basics',
  MESSAGING_BASICS = 'messaging-basics',
  TELEPHONY = 'telephony',
  VOICE_CALLS = 'voice-calls',
  MEMORIES = 'memories',
  EVALUATIONS = 'evaluations',
  ADVANCED = 'advanced'
}

export const GUEST_DASHBOARD_TABS = {
  OVERVIEW: 'overview',
  CONVERSATIONS: 'conversations',
  VOICE_CALLS: 'voice-calls',
  LEADS: 'leads',
  EVALUATIONS: 'evaluations'
};

export const DOCS_URL = 'https://docs.droxy.ai';

export const REDIRECT_SEARCH_PARAM_KEY = 'redirect';
